import { AppointableDTO } from "@gymflow/types";

export const appointableHelper = {
  /*** Gets the appointable host if there's only one available */
  getSingleHost: (appointable?: AppointableDTO) => {
    return appointable
      ? appointable.availabilityType === "FACILITY" &&
        appointable.appointableFacilities.length === 1
        ? appointable.appointableFacilities[0].id
        : appointable.availabilityType === "STAFF" &&
            appointable.appointableHosts.length === 1
          ? appointable.appointableHosts[0].id
          : undefined
      : undefined;
  },
  sortAppointable:
    (direction?: "ASC" | "DESC") => (a: AppointableDTO, b: AppointableDTO) => {
      if (direction === undefined) {
        const aDuration = a.duration;
        const bDuration = b.duration;
        return aDuration - bDuration;
      }
      const aPrice = a.price ?? 0;
      const bPrice = b.price ?? 0;
      if (aPrice !== bPrice) {
        return direction === "ASC" ? aPrice - bPrice : bPrice - aPrice;
      }
      const aSessionCost = a.sessionCost ?? 0;
      const bSessionCost = b.sessionCost ?? 0;
      if (aSessionCost !== bSessionCost) {
        return direction === "ASC"
          ? aSessionCost - bSessionCost
          : bSessionCost - aSessionCost;
      }
      const aDuration = a.duration;
      const bDuration = b.duration;
      return aDuration - bDuration;
    },
};
